<template>
  <div class="animated fadeIn col-md-12">
    <b-row>
      <b-col cols="12">
        <b-card>
          <div slot="header">
            <strong v-text="$lang.washup"></strong>
          </div>
          <div class="text-center" v-show="isLoading">
            <b-spinner variant="primary" label="Text Centered"></b-spinner>
          </div>
          <b-row>
            <div class="table-responsive" v-show="!isLoading">
              <table
                class="
                  washup-table
                  table
                  b-table
                  table-striped table-bordered
                  text-center
                  table-hover
                  align-middle
                "
              >
                <thead role="rowgroup" class="text-center">
                  <tr role="row">
                    <th class="empty"></th>
                    <th
                      :colspan="fields.length"
                      class="text-center align-middle"
                    >
                      تمرینات
                    </th>
                    <th colspan="2" class="text-center align-middle">جمع‌بندی</th>
                  </tr>
                </thead>
                <thead role="rowgroup">
                  <tr role="row" class="text-center">
                    <th class="empty text-danger text-center align-middle">
                      شایستگی‌ها
                    </th>
                    <th
                      class="text-center align-middle"
                      :key="index"
                      v-for="(field, index) in fields"
                    >
                      {{ field.name }}
                    </th>
                    <th class="text-center">نمره نهایی</th>
                    <th class="text-center">عملیات</th>
                  </tr>
                </thead>
                <tbody>
                  <tr :key="index" v-for="(item, index) in items">
                    <td class="text-danger align-middle">
                      {{ item.competency.name }}
                    </td>
                    <template v-for="(field, i) in fields">
                      <td
                        class="align-middle"
                        :key="i"
                        v-if="
                          item.scores.find((x) => x.exercise.id == field.id)
                        "
                      >
                        <b-input
                          type="text"
                          v-if="edit_row_id == item.competency.id"
                          v-model="
                            edit_row.scores.find(
                              (x) => x.exercise.id == field.id
                            ).center_execute_case_competency.score
                          "
                        >
                        </b-input>
                        <span v-else>{{
                          item.scores.find((x) => x.exercise.id == field.id)
                            .center_execute_case_competency.score
                        }}</span>
                      </td>
                      <td :key="i" v-else class="bg-secondary"></td>
                    </template>
                    <td>
                      <template v-if="edit_row_id == item.competency.id">
                        <b-form-group label-for="washup_score" :label-cols="12">
                          <b-form-input
                            id="washup_score"
                            type="number"
                            :autocomplete="$lang.edit_row.washup_score"
                            :state="
                              $v.edit_row.washup_score.$dirty
                                ? !$v.edit_row.washup_score.$error
                                : null
                            "
                            v-model="$v.edit_row.washup_score.$model"
                          ></b-form-input>
                          <b-form-invalid-feedback
                            v-if="!$v.edit_row.washup_score.required"
                            id="washup_score-feedback"
                          >
                            {{
                              $lang.error_required
                                | replace($lang.edit_row.washup_score)
                            }}
                          </b-form-invalid-feedback>
                          <b-form-invalid-feedback
                            v-if="
                              $v.edit_row.washup_score.required &&
                              !$v.edit_row.washup_score.minValue |
                                !$v.edit_row.washup_score.maxValue
                            "
                            id="washup_score-feedback"
                            >{{
                              $lang.error_Value
                                | replace($lang.edit_row.washup_score, 5, 0)
                            }}
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </template>

                      <span v-else>{{ item.washup_score }}</span>
                    </td>
                    <td>
                      <template v-if="edit_row_id == item.competency.id">
                        <b-button
                          variant="success"
                          @click="savingWashup()"
                          v-b-tooltip.hover
                          :title="$lang.washup_save"
                        >
                          <i class="fa fa-save"></i>
                        </b-button>
                        <b-button
                          variant="danger ml-1"
                          @click="cancelWashup(item)"
                          v-b-tooltip.hover
                          :title="$lang.washup_cancel"
                        >
                          <i class="fas fa-times"></i>
                        </b-button>
                      </template>
                      <template v-else>
                        <b-button
                          v-if="mode == 'view'"
                          variant="success ml-3"
                          @click="startWashup(item)"
                          v-b-tooltip.hover
                          :title="$lang.washup_start"
                        >
                          <i class="fa fa-edit"></i>
                        </b-button>
                      </template>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-row>
          <b-row v-if="mode == 'washup'">
            <b-col cols="12">
              <div class="col-md-12 text-center" v-show="indicatorLoading">
                <b-spinner variant="primary" label="Text Centered"></b-spinner>
              </div>
              <b-card
                v-show="!indicatorLoading"
                v-if="indicators && indicators != 'undefined'"
              >
                <div>
                  <b-tabs card vertical>
                    <b-tab v-for="(exercise, index) in exercises" :key="index">
                      <template v-slot:title>
                        <strong>{{ exercise.name }}</strong>
                      </template>
                      <div class="table-responsive">
                        <table
                          class="
                            washup-table
                            table
                            b-table
                            table-striped table-bordered
                            text-center
                            table-hover
                            align-middle
                          "
                        >
                          <thead role="rowgroup" class="text-center">
                            <tr role="row">
                              <th class="align-middle text-center">نشانگر</th>
                              <th class="align-middle text-center">مقدار</th>
                              <th class="align-middle text-center">مصداق</th>
                              <th class="align-middle text-center">وضعیت</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              :key="j"
                              v-for="(item, j) in indicators.find(
                                (x) => x.exercise.id == exercise.id
                              )['indicators']"
                            >
                              <td
                                v-bind:class="{
                                  'text-success': item.evidence.id,
                                  'align-middle': true,
                                }"
                              >
                                {{ item.indicator.caption }}
                              </td>
                              <td
                                v-bind:class="{
                                  'text-success': item.evidence.id,
                                  'align-middle': true,
                                }"
                              >
                                {{ item.indicator.value }}
                              </td>
                              <td
                                v-bind:class="{
                                  'text-success': item.evidence.id,
                                  'align-middle': true,
                                }"
                              >
                                {{ item.evidence.text }}
                              </td>
                              <td
                                v-bind:class="{
                                  'text-success': item.evidence.id,
                                  'align-middle': true,
                                }"
                              >
                                {{ item.evidence.status }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </b-tab>
                  </b-tabs>
                </div>
              </b-card>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  required,
  minValue,
  maxValue,
  numeric,
} from "vuelidate/lib/validators";

export default {
  validations: {
    name: {},
    description: {},
    category_selected: {},
    edit_row: {
      washup_score: {
        required,
        minValue: minValue(0),
        maxValue: maxValue(5),
        numeric,
      },
    },
  },
  name: "edit-washUp",
  components: {},
  props: {
    backUrl: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      center_execute_id: this.$route.params.center_execute_id,
      center_execute_candidate_id:
        this.$route.params.center_execute_candidate_id,
      fields: [],
      items: [],
      edit_row_id: 110,
      edit_row: null,
      isLoading: false,
      full_name: "",
      status: "",
      mode: "view",
      indicators: [],
      indicatorFields: [],
      indicatorLoading: false,
      exercises: [],
    };
  },
  methods: {
    saveWashupCompetency(washup) {
      let competency_scores = washup.scores.map((x) => {
        return {
          center_execute_case_id: x.center_execute_case_competency.case_id,
          score: x.center_execute_case_competency.score,
        };
      });
      let payload = {
        score: washup.washup_score,
        center_execute_case_competency: competency_scores,
      };
      return this.$httpService
        .put(
          this.$config.api_url +
            this.$config.kanoon.washup_competency_details
              .replace("{center_execute_id}", this.center_execute_id)
              .replace(
                "{center_execute_candidate_id}",
                this.center_execute_candidate_id
              )
              .replace("{competency_id}", washup.competency.id),
          payload
        )
        .then((response) => {
          this.$notify.success(response.data.message);
          return true;
        })
        .catch((err) => {
          this.$notify.error(err.response.data.message);
          return false;
        });
    },
    savingWashup() {
      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }
      this.isLoading = true;
      this.edit_row_id = null;
      this.mode = "view";
      this.indicators = null;
      this.saveWashupCompetency(this.edit_row).finally(() => {
        this.isLoading = false;
        this.fetchData();
        this.edit_row = [];
      });
    },
    startWashup(item) {
      this.mode = "washup";
      this.edit_row = item;
      this.edit_row_id = item.competency.id;
      this.indicatorLoading = true;
      this.getIndicators(item);
    },
    cancelWashup() {
      this.mode = "view";
      this.edit_row_id = null;
      this.indicators = null;
    },
    getIndicators(item) {
      return this.$httpService
        .get(
          this.$config.api_url +
            this.$config.kanoon.washup_competency_details
              .replace("{center_execute_id}", this.center_execute_id)
              .replace(
                "{center_execute_candidate_id}",
                this.center_execute_candidate_id
              )
              .replace("{competency_id}", item.competency.id)
        )
        .then((response) => {
          this.indicators = response.data.data.exercises;
          this.exercises = this.indicators.map((item) => item.exercise);
        })
        .catch((err) => {
          this.$notify.error(err.response.data.message);
        })
        .finally(() => (this.indicatorLoading = false));
    },
    handleBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
    },
    afterSave() {
      if (this.backUrl) {
        this.$router.push(this.backUrl);
      } else {
        this.handleBack();
      }
    },
    save() {
      this.isLoading = true;
      this.$v.$touch();
      if (this.$v.$anyError) {
        this.isLoading = false;
        return;
      }

      let payload = {
        name: this.name,
        description: this.description,
        category_id: this.category_selected.value,
      };
      this.$httpService
        .put(
          this.$config.api_url + this.$config.kanoon.competency + "/" + this.id,
          payload
        )
        .then((response) => {
          this.$notify.success(response.data.message);
          this.afterSave();
        })
        .catch((err) => {
          if (err.response.status === 400) {
            if (typeof err.response.data.message === "object") {
              err.response.data.message.forEach((element) => {
                this.errors.push(element);
              });
            } else {
              this.$notify.error(err.response.data.message);
            }
          } else {
            this.$notify.error(err.message);
          }
        });
    },
    fetchData() {
      if (
        isNaN(this.center_execute_candidate_id) ||
        isNaN(this.center_execute_id)
      ) {
        this.$notify.error("Not a number!");
        return false;
      }

      this.$httpService
        .get(
          this.$config.api_url +
            this.$config.kanoon.washup_details
              .replace("{center_execute_id}", this.center_execute_id)
              .replace(
                "{center_execute_candidate_id}",
                this.center_execute_candidate_id
              )
        )
        .then((response) => {
          let data = response.data.data;
          this.full_name = data.full_name;
          this.status = data.status;
          this.items = data.washup_details;

          let exercises = this.items
            .map((item) => item.scores.map((ex) => ex.exercise))
            .flat()
            .filter((v, i, a) => a.findIndex((i) => i.id === v.id) === i);
          this.fields = [...new Set(exercises.flat())];

          this.isLoading = false;
        })
        .catch((err) => {
          this.$notify.error(err.response.data.message);
        });
    },
  },
  watch: {},
  created() {
    this.isLoading = true;
    this.fetchData();
  },
};
</script>

<style scoped lang="css">
.btn {
  margin-bottom: 4px;
}

thead th.empty {
  background: none;
  border: 0;
}
</style>
